import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { SearchBox as CSearchBox } from '@zillow/constellation';

import {
    StyledSearchBoxContainer,
} from './StyledComponents';

const propTypes = {
    initialText: PropTypes.string,
    placeholder: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
};

const defaultProps = {
    initialText: '',
    placeholder: 'Search',
    onSubmit: () => { },
};

class SearchBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: props.initialText,
        };

        this.clearSearchTextAndUpdate = this.clearSearchTextAndUpdate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearchDebounced = debounce(this.props.onSearch, 200);
    }

    handleChange(e) {
        const searchText = e.target.value;
        this.setState({ searchText });
        this.handleSearchDebounced(searchText);
    }

    clearSearchTextAndUpdate() {
        this.updateSearchText(defaultProps.initialText);
        this.props.onSearch(defaultProps.initialText);
    }

    updateSearchText(newText = defaultProps.initialText) {
        this.setState({
            searchText: newText,
        });
    }

    handleSubmit = (e) => {
        if (e.key === 'Enter' && this.props.onSubmit) {
            this.props.onSubmit(this.state.searchText);
        }
    }

    render() {
        return (
            <StyledSearchBoxContainer className="SearchBox">
                <CSearchBox
                    inputId="SearchBox-Component"
                    className="SearchBox-Component"
                    input={(
                        <input
                            className="SearchBox-Input"
                            type="text"
                            placeholder={this.props.placeholder}
                            onChange={this.handleChange}
                            value={this.state.searchText}
                            onKeyPress={this.handleSubmit}
                        />
                    )}
                />
            </StyledSearchBoxContainer>
        );
    }
}

SearchBox.propTypes = propTypes;
SearchBox.defaultProps = defaultProps;

export { SearchBox };
export default SearchBox;
